import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { hsaMerchantClassificationProjection } from "./hsa-merchant-classification";

/** The team's merchant classification, or null before the first run. */
export const getHsaMerchantClassification = {
  name: "getHsaMerchantClassification" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    classification: hsaMerchantClassificationProjection.nullable(),
  }),
};
